<template src='./clone_price_list.html'></template>

<script>
import { API_URL } from '@/main'
import axios from "axios"
import router from '@/router/index.js'
import { fetchBases, fetchCurrencies, fetchCustomers, fetchFormulas, fetchGoodsKinds, fetchLocations, fetchMeasureUnits, fetchPackagingKinds, fetchPricesList, fetchVoices } from "@/commons.js"
import { genericFunction } from '@/commons.js'

import '@vuepic/vue-datepicker/dist/main.css'
import Datepicker from '@vuepic/vue-datepicker'
import { BModal } from 'bootstrap-vue-3'

export default {
  name: "ClonePriceList",
  components: {
    BModal, 
    Datepicker,
  },
  data() {
    return {
      action_selected: 0,
      alert_message: "",
      alert_variant: "",
      base: '',
      bases: [],
      bracket_measure_unit: '',
      calculation_formula: '',
      calculation_formulas: [],
      checkedRowsList: [],
      clones_list: [],
      clone_list_name: '',
      clone_list_names: [],
      currency: '',
      currencies: [],
      currentPage: 1,
      customer: '',
      customer_assign: null,
      customers_list: [],
      end_date: '',
      filter: {
        base_id: null,
        calculation_formula_id: null,
        currency_id: null,
        customer_id: null,
        formula_id: null,
        good_kind_id: null,
        location_code1_id: null,
        location_code2_id: null,
        measure_unit_id: null,
        packaging_kinds_id: null,
        price_list_name_id: null,
        unit_amount: null,
        unit_cost: null,
        voice_name_id: null,
      },
      goods_kinds: [],
      id: null,
      isLoading: false,
      location_code1: '',
      location_code2: '',
      locations: [],
      lower_end_bracket: null,
      measure_units: [],
      new_end_date: '',
      new_price_list_name: '',
      new_start_date: '',
      operations: [],
      packaging_kinds: [],
      paginationKey: 0,
      perPage: 10,
      price_list_names: [],
      row: {},
      rows: 0,
      selectedOperation: '',
      showAlert: false,
      showModal: false,
      sortBy: null,
      sortDesc: false,
      start_date: '',
      totalPages: 0,
      totalRows: 0,
      update_end_date: '',
      update_start_date: '',
      update_unit_amount: null,
      update_unit_amount_kind: null,
      update_unit_cost: null,
      update_unit_cost_kind: null,
      upper_end_bracket: null,
      voice_names: [],
    }            
  },
  watch: {
    currentPage(newVal, oldVal) {
  
      if(newVal !== oldVal) {
        
        this.loadData(newVal)
      }
    },
  },
  async mounted() {
    
    await this.loadBases()
    await this.loadCurrencies()
    await this.loadCustomers()
    await this.loadFormulas()
    await this.loadGoodKinds()
    await this.loadLocations()
    await this.loadMeasureUnits()
    await this.loadPackagesKinds()
    await this.loadPricesList()
    await this.loadVoices()
    this.operations = [
      {id: 1, value: "Clonare"},
      {id: 2, value: "Copiare"},
      {id: 3, value: "Aggiornare"},
    ]
  },
  created() {

    this.loadData()
  },
  methods: {
    applyCheckedState() {

      for(let index=0;index < this.clones_list.length; index++) {

        if(this.checkedRowsList.includes(this.clones_list[index].id)) {

          this.clones_list[index].checked = true
        }
      }
    },
    clearForm() {

      this.filter = {
        base_id: null,
        calculation_formula_id: null,
        currency_id: null,
        customer_id: null,
        formula_id: null,
        good_kind_id: null,
        location_code1_id: null,
        location_code2_id: null,
        measure_unit_id: null,
        packaging_kinds_id: null,
        price_list_name_id: null,
        unit_amount: null,
        unit_cost: null,
        voice_name_id: null,
      }
      this.end_date = ''
      this.selectedBase = null
      this.selectedCalculationFormula = null
      this.selectedCurrency = null
      this.selectedCustomer = null
      this.selectedGoodsKind = null
      this.selectedLocationId1 = null
      this.selectedLocationId2 = null
      this.selectedPackagingKind = null
      this.selectedPriceListName = null
      this.selectedUM = null
      this.selectedVoiceName = null      
      this.start_date = ''
      this.unit_amount = null
      this.unit_cost = null

      this.clones_list.forEach(row => {

        row.checked = false
      })
    },
    executeOperation() {

      this.showModal = true
    },
    async filterData() {

      let filters = {}

      for(const key in this.filter) {

        if(this.filter[key] !== null) {

          let value = this.filter[key];
          
          if(value instanceof Date) {

            const year = value.getFullYear()
            const month = String(value.getMonth() + 1).padStart(2, '0')
            const day = String(value.getDate()).padStart(2, '0')
            value = `${year}-${month}-${day}`
          }

          filters[key] = value
        }
      }

      const url = API_URL + "price_list/GetFilteredPricesList/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.get(url, {params: filters, headers: headers})
      this.checkedRowsList = response.data
      this.applyCheckedState()
    },
    formatDate(date) {
  
      if(!date) {

        return ''
      }

      return date.slice(8, 10) + "-" + date.slice(5, 7) + "-" + date.slice(0, 4)
    },    
    genericFunction, 
    getNestedValue(obj, path, defaultValue = '') {
      
      return path.split('.').reduce((acc, part) => acc && acc[part] !== undefined ? acc[part] : defaultValue, obj)
    },
    async handleOk(bvModalEvt) {

      let url = API_URL
      let params = {}

      if(this.action_selected == 1) {

        if(!this.customer_assign && !this.new_price_list_name) {

          this.alert_message = "Si deve indicare almeno uno dei due tra il nome di un listino o il nominativo di un cliente"
          this.alert_variant = "warning"
          this.showAlert = true
        }
        else {

          url += "price_list/ClonePriceList/"
          params = {
            customer: this.customer_assign,
            end_date: this.new_end_date,
            price_list_name: this.new_price_list_name,
            records: this.checkedRowsList,
            start_date: this.new_start_date,
          }
        }
      }
      else if(this.action_selected == 2) {

        url +="price_list/CopyPriceList/"
        params = {
          price_list_name: this.add_price_list_name,
          customer: this.add_customer,
          records: this.checkedRowsList,
        }
      }
      else if(this.action_selected == 3) {

        url +="price_list/UpdatePriceList/"
        params = {
          end_date: this.update_end_date,
          records: this.checkedRowsList,
          start_date: this.update_start_date,
          unit_amount: this.update_unit_amount,
          unit_amount_kind: this.update_unit_amount_kind,
          unit_cost: this.update_unit_cost,
          unit_cost_kind: this.update_unit_cost_kind,
        }
      }
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }

      const response = await axios.post(url, {params}, {headers})
      this.loadData()
      
      if(response.data.message == 'OK') {

      }
      else {


      }

      this.showModal = false
    },
    handlePageChange(page) {

      this.loadData(page)
    },
    async loadBases() {

      this.bases = await this.genericFunction('fetchBases')() || []
    },
    async loadCurrencies() {
    
      this.currencies = await this.genericFunction('fetchCurrencies')() || []
    },
    async loadCustomers() {
    
      this.customers_list = await this.genericFunction('fetchCustomers')() || []
    },
    async loadData(page = 1) {

      try {

        const url = API_URL + "price_list/PriceListList/"
        const headers = {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        }
        const params = {
          params: {page: page},
        }
        console.debug("*********************** loadData() headers", headers) /**/
        const response = await axios.get(url, {params: params, headers: headers})
        
        this.clones_list = response.data.results.map(row => ({
          id: row.id || -1,
          price_list_name: row.price_list_name || '',
          voice_name: row.voice_name || '',
          customer: row.customer || '',
          currency: row.currency?.currency || '',
          start_date: row.start_date || '',
          end_date: row.end_date || '',
          location_code1: row.location_code1?.location || '',
          location_code2: row.location_code2?.location || '',
          base: row.base || '',
          calculation_formula: row.calculation_formula?.formula || '',
          unit_amount: row.unit_amount || null,
          checked: false
        }))

        this.applyCheckedState()
        this.totalCount = parseInt(response.data.count, 10)
        this.perPage = parseInt(this.perPage, 10)
        this.totalPages = Math.ceil(response.data.count / this.perPage)
        this.currentPage = page
        this.paginationKey++

      } 
      catch (error) {
      
        console.error('Error fetching data:', error)
      }
    },
    async loadFormulas() {

      this.calculation_formulas = await this.genericFunction('fetchFormulas')() || []
    },
    async loadGoodKinds() {

      this.goods_kinds = await this.genericFunction('fetchGoodsKinds')() || []
    },
    async loadLocations() {

      this.locations = await this.genericFunction('fetchLocations')() || []
    },
    async loadMeasureUnits() {

      this.measure_units = await this.genericFunction('fetchMeasureUnits')() || []
    },
    async loadPackagesKinds() {

      this.packaging_kinds = await this.genericFunction('fetchPackagingKinds')() || []
    },
    async loadPricesList() {

      this.price_list_names = await this.genericFunction('fetchPricesList')() || []
      console.debug("price_list_names", this.price_list_names)
    },
    async loadVoices() {

      this.voice_names = await this.genericFunction('fetchVoices')() || []
    },
    onCheckboxChange(item) {      

      if(item.checked) {

        this.checkedRowsList.push(item.id)
      }
      else {

        this.checkedRowsList.splice(this.checkedRowsList.indexOf(item.id))
      }
    },   
    selectPriceLists() {

      /* If selected customer load only price_lists_names of this customer, otherwise load all */
    },
  }
}
</script>